import React, { createContext, useContext, useState } from "react"
import { AdminEmployeeProfile } from "../hooks/AdminEmployee/useGetAdminEmployeeProfile"

interface AdminEmployeeContextProps {
  adminEmployeeProfile: AdminEmployeeProfile | null
  setAdminEmployeeProfile: (profile: AdminEmployeeProfile | null) => void
}

const AdminEmployeeContext = createContext<AdminEmployeeContextProps | undefined>(undefined)

export const AdminEmployeeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [adminEmployeeProfile, setAdminEmployeeProfileState] = useState<AdminEmployeeProfile | null>(() => {
    const stored = localStorage.getItem("adminEmployeeProfile")

    return stored ? (JSON.parse(stored) as AdminEmployeeProfile) : null
  })

  const setAdminEmployeeProfile = (profile: AdminEmployeeProfile | null) => {
    setAdminEmployeeProfileState(profile)

    if (profile) {
      localStorage.setItem("adminEmployeeProfile", JSON.stringify(profile))
    } else {
      localStorage.removeItem("adminEmployeeProfile")
    }
  }

  return (
    <AdminEmployeeContext.Provider value={{ adminEmployeeProfile, setAdminEmployeeProfile }}>
      {children}
    </AdminEmployeeContext.Provider>
  )
}

export const useAdminEmployeeLogged = () => {
  const context = useContext(AdminEmployeeContext)

  if (!context) {
    throw new Error("useAdminEmployeeLogged deve ser usado dentro de um AdminEmployeeProvider")
  }

  return context
}
